import { render, staticRenderFns } from "./ActivityReservationTable.vue?vue&type=template&id=6311945a&scoped=true&"
import script from "./ActivityReservationTable.vue?vue&type=script&lang=js&"
export * from "./ActivityReservationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6311945a",
  null
  
)

export default component.exports